import loadable from '@loadable/component'

export const Identifiers = loadable(() => import('./Identifiers'))
export { default as identifiersMocks } from './__mocks__/Identifiers.mock'
export type { IdentifierItemProps, IdentifiersProps } from './Identifiers'
